import { Http,RequestOptions,Headers, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../global-service/global-service';
import { Observable } from 'rxjs';

const options = new RequestOptions({
  headers: new Headers({
    'Content-Type': 'application/json'
  })
});
@Injectable()
export class IncidentServiceProvider {
  baseUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;
  baseUrlTms: String = this.globalServiceProvider.appConfig.BaseApiTmsUrl;
  constructor(
    public http: Http,
    public globalServiceProvider: GlobalServiceProvider
  ) {
    console.log('Hello IncidentServiceProvider Provider');
  }
  getIncidents(custCode, pageNo) {
    let uri = this.baseUrl + '/api/incident/' + custCode  + '/' + pageNo;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  getIncident(pkid) {
    let uri = this.baseUrl + '/api/incident/'  + pkid;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  searchIncident(custCode, searchText) {
    let uri = this.baseUrl +'/api/incident/search';
    console.log('uri:',uri);
    let result = null;
    return this.http
      .post(uri, { data: searchText, custCode: custCode }, options)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  getJobTankerLocations(tanker) {
    let uri = this.baseUrl +'/api/mtdata/tankerposition';
    let result = null;
    return this.http
      .post(uri, { tanker: tanker }, options)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  getIncidentStatistic(custCode) {
    let uri = this.baseUrl +'/api/incident/statistic';
    let result = null;
    return this.http
      .post(uri, {"custCode": custCode}, options)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          // console.log('err: ', err);
          return null;
        }
      );
  }
  getConsignmentStatistic(custCode) {
    let uri = this.baseUrl +'/api/consignment/statistic';
    let result = null;
    return this.http
      .post(uri, {"custCode": custCode}, options)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
  getLegs(jobId) {
    let uri = this.baseUrl + '/api/jobs/legs/' + jobId;
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

addJobIncidentTms(data) {
  let uri = this.baseUrlTms +'/incidents/';
  let result:any={};
  return this.http
    .post(uri, data)
    .toPromise()
    .then(data1 => {
      result = data1.json();
      // console.log('result:',JSON.stringify(result));
      return result;
    })
    .catch(
      err => {
        console.log('err: ', JSON.stringify(err));
        return null;
      }
    );
}

getIncidentFromBSS(filter,condition): Observable<any> {
  let url = this.baseUrlTms +'/incidents';
  console.log('getIncidentFromBSS:',url);
    return this.http
      .get(url,  { params: { filter: filter, condition: condition } })
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
}

}




// WEBPACK FOOTER //
// ./src/providers/incident-service/incident-service.ts